/* eslint-disable */
const YANDEX_METRIKA_ID = 11881159;

export { YANDEX_METRIKA_ID };